import React, { useState, useEffect } from "react";

import Button from "react-bootstrap/Button";

function selectTemplate(type) {}

export const ReportTemplatesPicker = () => {
  return (
    <div className="templateContainer">
      <Button
        onClick={() => selectTemplate("performance")}
        variant="outline-primary"
        className="templateOptionButton"
      >
        <div>General Performance Jam</div>
      </Button>
      <Button
        onClick={() => selectTemplate("fraud")}
        variant="outline-primary"
        className="templateOptionButton"
      >
        <div>Fraud Check</div>
      </Button>
      <Button
        onClick={() => selectTemplate("investor")}
        variant="outline-primary"
        className="templateOptionButton"
      >
        <div>Investor Reporting</div>
      </Button>
    </div>
  );
};

export default ReportTemplatesPicker;
